import type { ReactNode } from 'react';
import { createContext } from 'react';
import { defaultMarker } from './DefaultMarker.js';

interface UnorderedListItemContextProps {
  marker?: ReactNode;
}

export const UnorderedListItemContext =
  createContext<UnorderedListItemContextProps>({
    marker: defaultMarker,
  });
